import { APICfg } from 'services/api/api'
import {
  APIOptionedPreset,
  optionedPackageWrite,
  OptionedPreset,
  optionedPresetParse,
  ProductPackage,
  ProductPreset,
} from './common'

export type DeliveryTimeLogic = 'packageStartTime'

export type APIFoodProductPreset = APIOptionedPreset & {
  logistic: ProductPreset
  deliveryTimeLogic?: DeliveryTimeLogic
}

export type FoodPreset = OptionedPreset & {
  logistic: number
  deliveryTimeLogic?: DeliveryTimeLogic
  logisticFull: ProductPreset
}

type APIFoodPackage = ProductPackage<APIFoodProductPreset>

export type FoodPackage = ProductPackage<FoodPreset>

const foodPresetParse = ({ logistic, ...rest }: APIFoodProductPreset) => ({
  ...optionedPresetParse(rest),
  logistic: logistic.id,
  logisticFull: logistic,
})

const apiCfg: APICfg = {
  endpoint: 'foodPackage',
  parse: ({ products, ...rest }: APIFoodPackage): FoodPackage => ({
    ...rest,
    products: products.map(foodPresetParse),
  }),
  write: async (req: FoodPackage): Promise<FoodPackage> =>
    optionedPackageWrite(req),
}

export default apiCfg
